import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OnDemandPickup } from 'src/app/core/models/operations/operations-on-demand-pickup.model';
import { ON_DEMAND_PICKUP_CONTROLS } from '../on-demand-pickup.constants';
import { SCHEDULING_CONSTANTS } from './scheduling-section.constants';

@Component({
  selector: 'app-scheduling-section',
  templateUrl: './scheduling-section.component.html',
  styleUrls: ['./scheduling-section.component.scss'],
  standalone: false,
  providers: [DecimalPipe],
})
export class SchedulingSectionComponent implements OnInit {
  @Input({ required: true }) data!: OnDemandPickup;
  @Input({ required: true }) form!: FormGroup;

  readonly SCHEDULING_CONSTANTS = SCHEDULING_CONSTANTS;
  readonly CONTROLS = ON_DEMAND_PICKUP_CONTROLS;

  convertedOrderDate!: string | null;
  convertedServiceDate!: string | null;

  constructor(
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
  ) {}

  ngOnInit() {
    this.convertDates();
  }

  convertDates(): void {
    this.convertedOrderDate = this.datePipe.transform(
      this.data.orderDate,
      'yyyy-MM-dd',
    );
    this.convertedServiceDate = this.datePipe.transform(
      this.data.serviceDate,
      'yyyy-MM-dd',
    );
  }

  get displayPickUpAmt(): string {
    const amt =
      this.data?.copAmountDue ??
      this.data?.pickUpAmt ?? // backward compatibility
      null;

    if (amt == null || amt <= 0) {
      return '-';
    }

    return this.decimalPipe.transform(amt, '1.2-2') ?? '-';
  }
}
